import { Button, ModalWindow, UIHeading2, UIText1 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './DailyrentReviewMobileModal.css';
import reviewImg from './assets/reviews-img.jpg';

interface IDailyrentReviewMobileModal {
  isOpen: boolean;
  downloadNativeAppUrl: string;
  onDownloadClick(): void;
  closeModal(): void;
}

export const DailyrentReviewMobileModal = ({
  isOpen,
  closeModal,
  downloadNativeAppUrl,
  onDownloadClick,
}: IDailyrentReviewMobileModal) => {
  const footerNode = React.useMemo(
    () => (
      <a data-name="DailyrentReviewMobileModalLink" href={downloadNativeAppUrl}>
        <Button size="L" fullWidth onClick={onDownloadClick}>
          Скачать приложение
        </Button>
      </a>
    ),
    [onDownloadClick, downloadNativeAppUrl],
  );

  return (
    <ModalWindow open={isOpen} onClose={closeModal} size="M" footer={footerNode} fixed={false}>
      <div className={styles['content']} data-name="DailyrentReviewMobileModal">
        <img className={styles['img']} src={reviewImg} alt="Иллюстрация отзывов" />
        <div className={styles['text']}>
          <UIHeading2 textAlign="center" display="block">
            Скачайте приложение, чтобы оставить отзыв
          </UIHeading2>
          <span className={styles['subtitle']}>
            <UIText1 textAlign="center" display="block">
              Скоро они появятся на всех платформах
            </UIText1>
          </span>
        </div>
      </div>
    </ModalWindow>
  );
};
